export default {
  today: {
    id: 'track_parcel_today',
    defaultMessage: 'Today',
  },
  singleDeliveryDate: {
    id: 'track_parcel_single_delivery_date',
    defaultMessage: '{weekday, html}, {month, html}. {day, html}',
  },
  sameMonthDeliveryDateRange: {
    id: 'track_parcel_same_month_delivery_date_range',
    defaultMessage: '{month, html}. {day1, html} - {day2, html}',
  },
  splitMonthDeliveryDateRange: {
    id: 'track_parcel_split_month_delivery_date_range',
    defaultMessage:
      '{month1, html}. {day1, html} - {month2, html}. {day2, html}',
  },
}
